import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { DatePickerType } from '@/constants/datePicker';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  bizType: BizType | null;
  targetId: string | null;
  calendarType: DatePickerType.WEEKLY | DatePickerType.MONTHLY | DatePickerType.YEARLY;
  startDate: string;
  endDate: string;
};

export type BusinessPerformance = {
  organizationCountStat?: {
    organizationCount: number;
    changeCountDiff: number;
  };
  requestEventCountStat: {
    requestCount: number;
    changeRate?: number;
  };
  completeEventCountStat: {
    completeCount: number;
    changeRate?: number;
  };
  completeEventRateStat: {
    completeRate?: number;
    changeRate?: number;
  };
};

export const getBusinessPerformance = (args: Args) => {
  return api<PcApiResponse<BusinessPerformance>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/statistics/business-performance`,
    args
  );
};
